import React from 'react';

import { useStep } from '../../../../controllers/edit-store/helpers';
import { EditStep } from '../../../../controllers/edit-store/state/types';

import { EditRotation } from './edit-rotation';
import { ListRotation } from './list-rotation';

const Sidebar = () => {
	const [step] = useStep();

	return (
		<>
			{step === EditStep.List && <ListRotation />}
			{step === EditStep.Detail && <EditRotation />}
		</>
	);
};

export { Sidebar };
